module.exports = "<span class=\"min-chart\">\r\n  <span class=\"percent\">{{ percent }}</span>\r\n  <mdb-easy-pie-chart [percent]=\"percent\" [options]=\"options\"></mdb-easy-pie-chart>\r\n</span>"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/easy-charts/chart-simple.component.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/easy-charts/chart-simple.component.html
// module chunks = main